export default "/images/TableMode.svg?8a824223d7672bd6314dafaf69a7de3b";